// The top-bar tabs S-Process owns, as opposed to a round's tabs.
//
// `roundPrimaryNav.ts` is the same idea for a round's nav, and the two are
// deliberately separate lists rather than one gated list. A round tab points
// inside the round you're in and disappears when you leave it; an app tab
// points at the same place from everywhere in the app. The SiteHeader
// appends these after the round's entries, so the round's own nav still reads
// on its own.
//
// The tabs lead with Home for the landing page, except inside a round, where
// the round's tabs take over and the app switcher leads home. A Home tab
// alone would only repeat the app switcher, so it's left out.
//
// These carry no phase visibility and no unseen dot — both of those are
// round-relative, and forms and teams aren't.
//
// Width note: the AppBar packs the nav row right-to-left, and inside a round
// at 1440px the round's own tabs already fill it. Added app tabs can push the
// row's last entries into More.

export type AppNavLinkDef = {
  key: string;
  label: string;
  href: string;
};

type AppNavContext = {
  inRound: boolean;
  teamsEnabled?: boolean;
  resourcesEnabled?: boolean;
};

export function buildAppNavEntries(ctx: AppNavContext): AppNavLinkDef[] {
  const tabs = listSProcessTabs(ctx);

  if (ctx.inRound || tabs.length === 0) {
    return tabs;
  }

  return [{ key: "home", label: "Home", href: "/" }, ...tabs];
}

function listSProcessTabs(ctx: AppNavContext): AppNavLinkDef[] {
  const tabs: AppNavLinkDef[] = [];

  if (ctx.teamsEnabled) {
    tabs.push({ key: "teams", label: "My Teams", href: "/teams" });
  }

  if (ctx.resourcesEnabled) {
    tabs.push({ key: "resources", label: "Resources", href: "/resources" });
  }

  return tabs;
}
